<template>
  <main class="patient-record" sticky-container>
    <header
      class="patient-record__header"
      v-sticky
      sticky-z-index="8"
      ref="header"
      on-stick="onStick"
    >
      <stats-header
        :blood-pressure="bloodPressure"
        :weight="weight"
        :cholesterolLDL="cholesterolLDLInPreferredUnit"
        :cholesterol-l-d-l-unit="cholesterolLDLPreferredUnitLabel"
        :glucose="glucoseInPreferredUnit"
        :glucose-unit="glucosePreferredUnitLabel"
        :knowledge-level-name="knowledgeLevelName"
        :behaviour-goals="behaviourGoals"
        :outcome-goals="outcomeGoals"
        :bmi="BMI"
        :bmi-date="BMIDate"
      >
        <template v-slot:button>
          <close-patient-record-button>
          </close-patient-record-button>
        </template>
      </stats-header>
    </header>
    <div class="patient-record__wrapper" sticky-container>
      <nav
        class="patient-record__navigation"
        v-if="$vuetify.breakpoint.mdAndUp"
        ref="navigation"
      >
        <tablet-menu></tablet-menu>
      </nav>
      <div class="patient-record__content" ref="content">
        <router-view></router-view>
      </div>
    </div>
  </main>
</template>

<script>
import { mapGetters } from 'vuex';

import StatsHeader from 'dashboard/templates/components/Parts/StatsHeader';
import TabletMenu from 'dashboard/templates/components/Parts/TabletMenu';
import ClosePatientRecordButton from '../../components/Patient/ClosePatientRecordButton';

/**
 * Component PatientRecord.vue
 *
 * @module PatientRecord
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.3] app/src/APP_DASHBOARD/templates/views/Patient/PatientRecord.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: 'PatientRecord',
  components: {
    StatsHeader,
    TabletMenu,
    ClosePatientRecordButton,
  },
  data() {
    return {
      navOffset: { top: 0 },
    };
  },
  computed: {
    ...mapGetters({
      bloodPressure: 'patientSummary/bloodPressure',
      weight: 'patientSummary/weight',
      cholesterolLDLInPreferredUnit: 'patientSummary/cholesterolLDLInPreferredUnit',
      cholesterolLDLPreferredUnitLabel: 'patientSummary/cholesterolLDLPreferredUnitLabel',
      glucoseInPreferredUnit: 'patientSummary/glucoseInPreferredUnit',
      glucosePreferredUnitLabel: 'patientSummary/glucosePreferredUnitLabel',
      knowledgeLevelName: 'patientSummary/knowledgeLevelName',
      behaviourGoals: 'patientSummary/behaviourGoals',
      outcomeGoals: 'patientSummary/outcomeGoals',
      BMI: 'patientSummary/BMI',
      BMIDate: 'patientSummary/BMIDate',
    }),
  },
  methods: {
    onStick({ sticked }) {
      const { header, navigation, content } = this.$refs;

      if (!navigation) return;

      if (sticked) {
        navigation.style['height'] = `calc(100vh - ${header.offsetHeight}px)`;
        navigation.style['top'] = `${header.offsetHeight}px`;
        navigation.style['position'] = 'fixed';

        if (this.$vuetify.breakpoint.mdAndUp) {
          content.style['margin-left'] = `${navigation.offsetWidth}px`;
        }
      } else {
        navigation.style['height'] = 'unset';
        navigation.style['top'] = 'unset';
        navigation.style['position'] = 'static';
        content.style['margin-left'] = '0';
      }
    }
  },
};
</script>

<style lang="scss">
.patient-record {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}

.patient-record__wrapper {
  display: flex;
  flex-grow: 1;
}

.patient-record__header,
.patient-record__navigation {
  background-color: #fff;
}

.patient-record__content {
  flex-grow: 1;
  padding: 16px 4px 16px 4px;
}

.v-application.md-up {
  .patient-record__content {
    padding: 24px 12px 24px 24px;
  }
}
</style>
